module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', {
    attrs: {
      "is-show-back": false
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("公众号管理")])]), _vm._v(" "), _c('section', {
    staticClass: "list-cont"
  }, [_c('ul', {
    staticClass: "fx fx-wrap"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'wxAuth'
      },
      "tag": "li"
    }
  }, [_c('span', {
    staticClass: "icon-wechet"
  }), _vm._v(" "), _c('p', [_vm._v("公众号接入")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'wxMember'
      },
      "tag": "li"
    }
  }, [_c('span', {
    staticClass: "icon-member"
  }), _vm._v(" "), _c('p', [_vm._v("粉丝管理")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'wxMenu'
      },
      "tag": "li"
    }
  }, [_c('span', {
    staticClass: "icon-wxmenu"
  }), _vm._v(" "), _c('p', [_vm._v("菜单管理")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'wxMass'
      },
      "tag": "li"
    }
  }, [_c('span', {
    staticClass: "icon-mass"
  }), _vm._v(" "), _c('p', [_vm._v("群发管理")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'wxMaterial'
      },
      "tag": "li"
    }
  }, [_c('span', {
    staticClass: "icon-material"
  }), _vm._v(" "), _c('p', [_vm._v("素材管理")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'wxKeyWords'
      },
      "tag": "li"
    }
  }, [_c('span', {
    staticClass: "icon-key"
  }), _vm._v(" "), _c('p', [_vm._v("关键词管理")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'wxReply'
      },
      "tag": "li"
    }
  }, [_c('span', {
    staticClass: "icon-reply"
  }), _vm._v(" "), _c('p', [_vm._v("自动回复")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-34339a92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/wechat/Index.vue
// module id = 829
// module chunks = 0